/* --- START: src/components/FeedbackModal.js --- */
import React, { useState } from 'react';
import ReactDOM from 'react-dom'; // Import ReactDOM
import { supabase } from '../supabaseClient';
import './FeedbackModal.css';

function FeedbackModal({ isOpen, onClose, ruleId }) {
    const [type, setType] = useState('bug');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!message.trim()) return;
        setIsSubmitting(true);
        
        try {
            const { data: { user } } = await supabase.auth.getUser();
            
            const { error } = await supabase
                .from('user_feedback')
                .insert([{
                    user_id: user?.id,
                    user_email: user?.email,
                    type: type,
                    message: message,
                    rule_id: ruleId || null,
                    status: 'new'
                }]);

            if (error) throw error;

            setMessage('');
            onClose();
            alert("Thank you! Our team has received your report.");
        } catch (error) {
            console.error("Error submitting feedback:", error);
            alert("Failed to send. Please check your connection.");
        } finally {
            setIsSubmitting(false);
        }
    };

    // Use createPortal to render outside the App hierarchy
    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose} style={{ zIndex: 5000 }}>
            <div className="feedback-modal theme-aware" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Report Issue</h3>
                    <button className="icon-btn close-btn" onClick={onClose}>&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Issue Type</label>
                        <select value={type} onChange={e => setType(e.target.value)}>
                            <option value="bug">Technical Bug</option>
                            <option value="correction">Content Error</option>
                            <option value="feature">Feature Request</option>
                        </select>
                    </div>
                    
                    {ruleId && (
                        <div className="context-banner">
                            <span className="material-symbols-outlined">description</span>
                            <span>Context Rule ID: {ruleId}</span>
                        </div>
                    )}

                    <div className="form-group">
                        <label>Message</label>
                        <textarea 
                            value={message} 
                            onChange={e => setMessage(e.target.value)} 
                            placeholder="Describe the issue in detail..."
                            rows="5"
                            required
                        />
                    </div>
                    
                    <div className="modal-actions">
                        <button type="button" className="btn secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="btn" disabled={isSubmitting}>
                            {isSubmitting ? 'Sending...' : 'Submit Report'}
                        </button>
                    </div>
                </form>
            </div>
        </div>,
        document.body // Render target
    );
}

export default FeedbackModal;
/* --- END: src/components/FeedbackModal.js --- */